"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMAIL_MAKER_VIEW_IDS = [
    'sideBySide',
    'editor',
    'preview',
    'template',
    'send',
    'new',
    'ads',
];
exports.EMAIL_MAKER_DEFAULT_VIEW_ID = 'sideBySide';
//# sourceMappingURL=types.js.map